import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Phone, Smartphone, MapPin, ExternalLink } from "lucide-react";

const COL = [
  { title: "Courses", links: [["AI", "/courses/ai"], ["Real Estate", "/courses/real-estate"], ["Insurance", "/courses/insurance"], ["Loans", "/courses/loans"]] },
  { title: "Webinars", links: [["AI", "/webinars/ai"], ["Real Estate", "/webinars/real-estate"], ["Insurance", "/webinars/insurance"], ["Loans", "/webinars/loans"]] },
  { title: "Company", links: [["About", "/about"], ["Contact", "/contact"], ["How It Works", "/how-it-works"], ["Verify Certificate", "/verify"]] },
  { title: "Legal", links: [["Terms", "/terms"], ["Privacy", "/privacy"], ["Refund Policy", "/refund"], ["Cookie Policy", "/cookies"]] },
];

const NETWORK = [
  ["aiscaleforce.com", "https://aiscaleforce.com"],
  ["aigigjobs.com", "https://aigigjobs.com"],
  ["aiscaleforce.in", "https://aiscaleforce.in"],
  ["gtforce.world", "https://gtforce.world"],
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-asf-surface mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <Logo />
          <p className="text-sm text-slate-500 mt-4 max-w-xs">Learn AI. Master Industries. Build Your Future. Live webinars and practical, industry-focused courses.</p>
          <div className="mt-5 space-y-2 text-sm text-slate-600">
            <a href="tel:+918925937578" data-testid="footer-phone-in" className="flex items-center gap-2 hover:text-asf-orange transition-colors">
              <Smartphone className="h-4 w-4 text-asf-orange shrink-0" /> India: 89259 37578
            </a>
            <a href="tel:+14784007485" data-testid="footer-phone-global" className="flex items-center gap-2 hover:text-asf-orange transition-colors">
              <Phone className="h-4 w-4 text-asf-orange shrink-0" /> Global: +1 478 400 7485
            </a>
            <div className="flex items-start gap-2" data-testid="footer-address">
              <MapPin className="h-4 w-4 text-asf-orange shrink-0 mt-0.5" />
              <span>RMZ Millenia Phase 2, Campus 2, 10th Floor,<br />MGR Salai, Perungudi, Chennai 600096</span>
            </div>
          </div>
        </div>
        {COL.map((c) => (
          <div key={c.title}>
            <div className="asf-overline mb-3">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-slate-500 hover:text-asf-orange transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Network */}
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="asf-overline">Our Network</span>
          <div className="flex flex-wrap gap-2" data-testid="footer-network">
            {NETWORK.map(([label, href]) => (
              <a key={label} href={href} target="_blank" rel="noreferrer"
                data-testid={`network-${label}`}
                className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-asf-orange border border-slate-200 hover:border-asf-orange/40 rounded-full px-4 py-1.5 transition-colors bg-white">
                {label} <ExternalLink className="h-3.5 w-3.5" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-slate-200 py-6 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} AI Scale Force Store · aiscaleforce.store
      </div>
    </footer>
  );
}
